<template>

  <div>

  <loading-data-page-container v-if="loading || loadingError" :loading="loading" :loading-error="loadingError" :loading-error-message="loadingErrorMsg" class="antraege--page"><div/>
  </loading-data-page-container>

  <!-- classes stepper-page-container stepper-page are needed for imported stylesheet -->
  <div v-else class="stepper-page-container">

    <v-container fluid class="aenderungumfang-page stepper-page" :class="{'stepper-page-wide': isYoligWideScreen}">

      <div id="stepperpageContent"
           :class="showSummaryBox ? '' : 'centered'"
           class="area-content">

        <v-stepper :value="currentStepNumber"
                   alt-labels>

          <div id="custom-header-stepper"
               class="scroll-up-stepper white">

            <v-stepper-header class="custom-stepper">
              <template v-for="step in allSteps">

                <v-stepper-step ref="'stephead' + step.number"
                                :key="'stepkey' + step.number"
                                :class="{toplabel: step.number % 2 === 0}"
                                :complete="step.complete"
                                :step="step.number">{{ step.title }}
                </v-stepper-step>

                <v-divider v-if="step.number < allSteps.length"
                           :key="'dividerkey' + step.number" />

              </template>
            </v-stepper-header>

            <v-divider />

          </div>

          <v-stepper-content step="1"
                             class="mb-0 pa-0">

            <base-data ref="compStep1" aenderung state-path="editContract"/>

            <v-row no-gutters
                   class="stepperbuttons">
              <v-btn class="standard-button"
                     @click="cancel">Abbrechen</v-btn>
              <v-spacer/>
              <v-btn color="primary"
                     class="standard-button"
                     @click="stepForward">Weiter</v-btn>
            </v-row>

          </v-stepper-content>

          <v-stepper-content step="2"
                             class="mb-0 pa-0">
            <privat-step2 ref="compStep2"
                          :producterror="producterror"
                          aenderung
                          state-path="editContract"
                          class="privat-step2"
                          @producterror="producterror = false"
                          @step-forward="stepForward"
                          @step-back="stepBack" />
          </v-stepper-content>

          <v-stepper-content step="3"
                             class="mb-0 pa-0">
            <div class="semanticsection-title2 primary--text first">Beitragszahlung</div>
            <praemienzahlung ref="compStep3"
                             state-path="editContract"
                             form-ref="zahlung-form"
                             aenderung />

            <v-row no-gutters
                   class="stepperbuttons">
              <v-btn color="primary"
                     class="standard-button"
                     @click="stepBack">Zurück
              </v-btn>
              <v-spacer />
              <v-btn color="primary"
                     class="standard-button"
                     @click="stepForward">Weiter
              </v-btn>
            </v-row>
          </v-stepper-content>

          <v-stepper-content step="4"
                             class="mb-0 pa-0">
            <privat-step4 ref="compStep4"
                          state-path="editContract"
                          aenderung
                          @step-forward="stepForward"
                          @step-back="stepBack" />
          </v-stepper-content>

          <v-stepper-content step="5"
                             class="mb-0 pa-0">
            <privat-step5 ref="compStep5"
                          state-path="editContract"
                          aenderung
                          @step-forward="stepForward"
                          @step-back="stepBack" />
          </v-stepper-content>

        </v-stepper>

      </div>

      <div v-if="showSummaryBox"
           class="area-summary-box">
        <summary-box state-path="editContract"
                     @kurzangebot="createAenderungPageAngebot('Kurzangebot')" />
      </div>

    </v-container>

    <error-message-display :errors="errorSnackbar" />

    <v-dialog
      v-model="angebotDialog.show"
      :width="angebotDialog.width"
      :persistent="!angebotDialog.isSuccess && !angebotDialog.isError"
      content-class="angebot-dialog">
      <angebot-dialog :title="angebotDialog.title"
                      :success="angebotDialog.isSuccess"
                      :error="angebotDialog.isError"
                      :sus="getSuS"
                      @close="angebotDialog.show=false"
                      @open-angebot="openAngebot"/>
    </v-dialog>

  </div>

  </div>
</template>
<script>
require('@/assets/css/stepperstyle.css');

import StepperPageMixin from "@/components/privatkundenrechner/StepperPageMixin";
import BaseData from "@/components/privatkundenrechner/BaseData";
import PrivatStep2 from "@/components/privatkundenrechner/PrivatStep2";
import PrivatStep4 from "@/components/privatkundenrechner/PrivatStep4";
import PrivatStep5 from "@/components/privatkundenrechner/PrivatStep5";
import Praemienzahlung from "@/components/privatkundenrechner/Praemienzahlung";
import AngebotDialog from "@/components/privatkundenrechner/AngebotDialog";
import ErrorMessageDisplay from "@/components/ErrorMessageDisplay";
import SummaryBox from "@/components/privatkundenrechner/SummaryBox";
import httpService from '@/helper/httpService';
import {modernAntraege as dummyData} from '@/store/dummyData/Antraege';
import LoadingDataPageContainer from "@/components/kundenverwaltung/LoadingDataPageContainer";
import { CONNECTION_ERROR_MESSAGE } from "@/helper/httpService";
import { AENDERUNG_PAGE_NAMES } from "@/components/kundenverwaltung/valueLists";
import { INIT_PRAEMIEN} from "@/store/actionTypes";

export default {
  name: 'AenderungUmfangPage',
  components: { LoadingDataPageContainer, BaseData, PrivatStep2, Praemienzahlung, PrivatStep4, PrivatStep5, AngebotDialog, ErrorMessageDisplay, SummaryBox },
  mixins: [ StepperPageMixin ],
  data() {
    return {
      loading: true,
      loadingError: false,
      loadingErrorMsg: '',
      data: this.$route.params['data'],
      tmpStoreState: {},
      cancelled: true
    };
  },
  computed: {
    productLine () {
      return this.$store.state.editContract.productLine;
    },
    allSteps () {
      return this.$store.state.s.aenderung.steps;
    },
    currentStepNumber () {
      return this.$store.state.s.aenderung.activeStepNumber;
    },
    getSuS() {
      return this.$store.state.editContract.sus;
    },
    isYoligWideScreen() {
      return !!(this.$store.getters.activeStepNumberAenderung === 2 && this.$store.getters.showYoligMatrix('editContract')
        && this.$store.getters.isSusAvailable && !this.$store.state.editContract.nurnachhaltig);
    }
  },
  created() {
    this.$store.dispatch(INIT_PRAEMIEN);
    this.tmpStoreState = JSON.parse(JSON.stringify(this.$store.state.editContract));
    this.$store.commit('markAsChanged', { section: AENDERUNG_PAGE_NAMES.umfang });
    let loadAngebot = this.$route.params['art'] !== 'vertrag';
    if (!this.data) {
      Promise.resolve()
        .then(() => {
          let id = this.$route.params['nummer'];
          if (this.$route.params['art'] === 'vertrag') {
           return httpService.getVertrag(id);
          } else {
            return httpService.getAngebot(id);
          }
        })
        .then(data => {
          this.data = data;
          if (loadAngebot) this.$store.dispatch('loadAenderungsAngebot', this.data);
          this.loading = false;
        })
        .catch(err => {
          console.log(`GET CONTRACTS failed with ${err.status}: ${err.message}`);
          this.loadingErrorMsg = err.status < 500 ? `${loadAngebot ? 'Angebot' : 'Vertrag'} nicht gefunden` : CONNECTION_ERROR_MESSAGE;
          this.loadingError = true;
          this.loading = false;
          //TODO delete dummy data for production
          if (this.$store.state.env.environment === 'development') {
            this.data = Object.assign({}, dummyData[0]);
            if (loadAngebot) this.$store.dispatch('loadAenderungsAngebot', this.data);
            this.loading = false;
          }
        });
    } else {
      if (loadAngebot) this.$store.dispatch('loadAenderungsAngebot', this.data);
      this.loading = false;
    }
  },
  beforeDestroy () {
    if (this.cancelled) this.$store.commit('restoreAenderungState', this.tmpStoreState);
  },
  methods: {
    cancel() {
      this.$store.commit('restoreAenderungState', this.tmpStoreState);
      this.$router.go(-1);
    },
    stepBack() {
      this.doStep('aenderung', this.currentStepNumber, this.currentStepNumber - 1);
    },
    stepForward() {
      this.doStep('aenderung', this.currentStepNumber, this.currentStepNumber + 1);
    },
    createAenderungPageAngebot(type) {
      this.createAngebot(type, 'editContract');
    },
    stepSuccess(page, fromstep, tostep) {
      if (fromstep === this.allSteps.length) {
        this.cancelled = false;
        this.$router.push({
          name: 'AenderungsantragPage',
          params: {
            vertragsnummer: this.$store.state.editContract.vertragsnummer,
            vertrag: this.data
          }
        });
      } else {
        if (fromstep < tostep) {
          this.$store.commit("setStepComplete", {
            page: page,
            stepNumber: this.currentStepNumber
          });
        }
        this.$store.commit("doStepTo", {
          page: page,
          stepNumber: tostep
        });
        window.scrollTo(0, 0);
      }
    }
  }
};
</script>
<style>
/* general stepper stylings: see assets/css/stepperstyle */
.aenderungumfang-page .stepperbuttons .standard-button:not(.primary) {
  box-shadow: none;
  -webkit-box-shadow: none;
}
</style>
